/*
 * -----------------------------------------------------------------------
 *  <copyright file="header-options.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ExportExcelComponent from '../export-excel';
import IHeaderOptions from './header-options.interface';
import { useTranslation } from 'hooks';
import './styles.scss';
import { compareColumnsByOrderIndex } from '@utils/grid';

const HeaderOptions = ({
    options,
    clearFilters,
    expandAll,
    collapseAll,
    actions,
    checkedRows,
    excelExportOptions,
}: IHeaderOptions) => {
    const { t } = useTranslation();

    return (
        <div>
            {options && (
                <div className="header-menu-options">
                    <div className={`top-part ${options && !options.allowExpandCollapseAll ? 'only-clear' : ''}`}>
                        {options.allowExpandCollapseAll && (
                            <div className="expand-collapse-menu">
                                <span
                                    className={`expand-wrapper ${options.expandedItems ? 'disabled' : ''}`}
                                    onClick={expandAll}
                                    data-testid="grid-expand-all"
                                >
                                    <p>{t('expandAll')}</p>
                                </span>
                                <span className="divider">|</span>
                                <span
                                    className={`collapse-wrapper ${!options.expandedItems ? 'disabled' : ''}`}
                                    onClick={collapseAll}
                                    data-testid="grid-collapse-all"
                                >
                                    <p>{t('collapseAll')}</p>
                                </span>
                            </div>
                        )}
                        <div className="excel-clear-wrapper">
                            {options.allowExcelExport && (
                                <span className="excel-saver">
                                    <ExportExcelComponent
                                        data={excelExportOptions?.exportData}
                                        fileName={excelExportOptions?.fileName ?? ''}
                                        columns={excelExportOptions?.columns.sort(compareColumnsByOrderIndex)}
                                        mapColumns={excelExportOptions?.mapColumns}
                                    />
                                    <span>|</span>
                                </span>
                            )}
                            {!options.allowExcelExport && !!actions && (
                                <div className="action-items">
                                    {actions.map((item: any, key: number) => (
                                        <div
                                            key={key}
                                            className={`action-item ${!item.enabled(checkedRows) ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (item.enabled(checkedRows)) item.onClick(checkedRows);
                                            }}
                                        >
                                            {item.icon && (
                                                <FontAwesomeIcon className="action-icon" icon={['fal', item.icon]} />
                                            )}
                                            <p className="action-label">{item.label}</p>
                                        </div>
                                    ))}
                                    <span>|</span>
                                </div>
                            )}
                            {clearFilters && (
                                <span
                                    data-testid="grid-clear-filters"
                                    className={`clear-filters ${!options.appliedFilters ? 'disabled' : ''}`}
                                    onClick={clearFilters}
                                >
                                    <FontAwesomeIcon className="icon" icon={['fas', 'filter']} />
                                    <p>{t('clearFilters')}</p>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HeaderOptions;
